/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import klass from"../base/klass";export default klass.createAbstract({},{_keys:null,_chars:null,init:klass.abstractFn,_keyHandler:klass.abstractFn,getMappedKey:klass.abstractFn,getKeyMapping:klass.abstractFn,deinit:klass.abstractFn});